'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FaWpbeginner = function FaWpbeginner(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm8.6 18.6h3.5v-5h-3.5v5z m18.7 7.4v-2.1q-2.4 0.8-5.5 0.9-3 0-5.8-1.1t-4.9-2.7l0 2.1q2 1.8 4.8 2.9t6 1.1q2.9 0 5.4-1.1z m-13-7.4h14.3v-5h-14.3v5z m25.7-0.7q0 4.1-2.2 7.8 2 2.3 2 5.1 0 3.5-2.9 6t-7 2.5q-2.7 0-5-1.2t-3.6-3.1q-0.5 0-1.3 0t-1.3 0q-1.3 1.9-3.6 3.1t-5 1.2q-4.1 0-7-2.5t-2.9-6q0-2.8 2-5.1-2.2-3.7-2.2-7.8 0-4.7 2.7-8.6t7.3-6.3 10-2.3 10 2.3 7.3 6.3 2.7 8.6z' })
        )
    );
};

exports.default = FaWpbeginner;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/fa/wpbeginner.js
// module id = 676
// module chunks = 58411574672382 79611799117203 84521481881339